import Home from "./Home";
import Terms from "./Terms";
import Contact from "./Contact";

export default [
    {
        name: "app.home",
        path: "/",
        component: Home,
        meta: { requiresAuth: false }
    },
    {
        name: "app.terms",
        path: "/terms",
        component: Terms,
        meta: { requiresAuth: false }
    },
    {
        name: "app.contact",
        path: "/contact",
        component: Contact,
        meta: { requiresAuth: false }
    },
  ];